<template>
  <div class="input-group">
    <FormLabel
      :prepend="prepend"
      :required="required">
      <span
        slot="apendLabel"
        class="input-group-text time-format-label mr-0 ml-0 pr-0 pl-0">
        ({{ $t('TIME_ENTRIES.TIME_FORMAT_LABEL') }})
      </span>
      <money
        v-model="newTimeValue"
        v-bind="money"
        :class="{'text-left': align == 'left', 'text-right': align == 'right', 'text-center': align == 'center'}"
        :disabled="disabled"
        class="form-control"/>
    </FormLabel>
  </div>
</template>

<script>
import { Money } from 'v-money';
import FormLabel from '@/components/Forms/FormLabel';

export default {
  name: 'FormTimeInput',
  components: { FormLabel, Money },
  props: {
    value: {
      type: String,
      default: '0:00',
    },
    prepend: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'left',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newTimeValue: this.value,
      money: {
        decimal: ':',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) this.newTimeValue = newVal;
      },
      immediate: true,
    },
    newTimeValue: {
      handler(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 365px) {
  .time-format-label {
    font-size: 1.1REM;
  }
}
</style>
